<template>
  <div class="site2026">
    <Site2026Header />
    <div class="nav-spacer" />
    <main ref="main">
      <router-view :key="$route.path" />
    </main>
    <Site2026Footer />
  </div>
</template>

<script>
import Site2026Header from '@/components/site2026/Header'
import Site2026Footer from '@/components/site2026/Footer'
import { bindSite2026Motion, refreshSite2026Motion, unbindSite2026Motion } from '@/utils/site2026Motion'

export default {
  name: 'Site2026Layout',
  components: { Site2026Header, Site2026Footer },
  mounted() {
    this.ensureInter()
  },
  beforeDestroy() {
    if (this._motionRefreshTimer) clearTimeout(this._motionRefreshTimer)
    unbindSite2026Motion()
  },
  watch: {
    '$route.path': {
      handler() {
        this.$nextTick(() => {
          requestAnimationFrame(() => this.initPageMotion())
        })
      },
      immediate: true
    }
  },
  methods: {
    initPageMotion() {
      const main = this.$refs.main
      const root = main && main.firstElementChild
      if (!root) return
      root.classList.remove('is-page-ready', 'is-ready')
      root.removeAttribute('data-site2026-motion-root')
      const isHome = this.$route.name === 'Home'
      const opts = { skipEnhance: isHome }
      bindSite2026Motion(root, opts)
      if (this._motionRefreshTimer) clearTimeout(this._motionRefreshTimer)
      this._motionRefreshTimer = setTimeout(() => {
        refreshSite2026Motion(root, opts)
      }, 160)
    },
    ensureInter() {
      if (document.getElementById('site2026-inter-font')) return
      const pre1 = document.createElement('link')
      pre1.rel = 'preconnect'
      pre1.href = 'https://fonts.googleapis.com'
      document.head.appendChild(pre1)
      const pre2 = document.createElement('link')
      pre2.rel = 'preconnect'
      pre2.href = 'https://fonts.gstatic.com'
      pre2.crossOrigin = 'anonymous'
      document.head.appendChild(pre2)
      const link = document.createElement('link')
      link.id = 'site2026-inter-font'
      link.rel = 'stylesheet'
      link.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap'
      document.head.appendChild(link)
    }
  }
}
</script>

<style lang="scss">
@import '~@/styles/site2026/index.scss';
</style>
